// import i18n from '@/i18n/index'

export default {
  tableDataItem: [{
    prop: 'id',
    label: '',
    Object: 'value',
    width: '80'
  }, {
    prop: 'host_name',
    label: '',
    Object: 'value',
    width: '180'
  }, {
    prop: 'commission_amount',
    label: '',
    Object: 'value',
    width: '120'
  }, {
    prop: 'commission_type',
    label: '',
    Object: 'value',
    width: '120'
  }, {
    prop: 'delivery_order',
    label: '',
    Object: 'value',
    width: '120'
  }, {
    prop: 'created_at',
    label: '',
    Object: 'value',
    width: '120'
  }, {
    prop: 'commission_status',
    label: '',
    Object: 'value',
    width: '120'
  }]
}
